import React, { useContext, useEffect, useMemo, useState } from "react";
import {
  checkEmpty,
  clearToken,
  getToken,
  getUserMe,
  isAdmin,
  logoutApi,
  parseJwt,
  pathRoutes,
  testConn,
} from "../service/util.service";

import styles from "./Menu.module.css";
import { Button, Drawer, Menu } from "antd";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../App.context";
import { MenuOutlined } from "@ant-design/icons";

export let menuNotAdmin = [
  {
    label: "ลงหวย",
    key: "main",
  },
  {
    label: "บิลหวย",
    key: "summary",
  },
  {
    label: "สรุปหวยตามชนิด",
    key: "lot-summary",
  },
  {
    label: "สรุปหวยตามเลข",
    key: "number-lot-summary",
  },
  // {
  //   label: "ตรวจ",
  //   key: "check",
  // },
  {
    label: "ตรวจรางวัล",
    key: "lot-resualt",
  },
  {
    label: "ตรวจรางวัลรวมหวย",
    key: "version2-resualt",
  },
];
export let menuAdmin = [
  {
    label: "เลือกคน",
    key: "select-user",
  },
  {
    label: "บิลหวย",
    key: "summary",
  },
  {
    label: "สรุปหวยตามชนิด",
    key: "lot-summary",
  },
  {
    label: "สรุปหวยตามเลข",
    key: "number-lot-summary",
  },
  {
    label: "ใส่รางวัล",
    key: "lot-resualt",
  },
  {
    label: "ตรวจรางวัลรวมหวย",
    key: "version2-resualt",
  },
];

const MenuTop = () => {
  const [openMenu, setopenMenu] = useState(false);
  if (!checkEmpty(getToken())) {
    return (
      <>
        <div
          className={styles.menuIcon}
          style={{ backgroundColor: "white", height: "60px" }}
        >
          <MenuOutlined
            style={{
              color: "black",
              fontSize: "30px",
              paddingLeft: "12px",
              paddingTop: "12px",
            }}
            onClick={() => {
              setopenMenu(true);
            }}
          />
        </div>
        <div className={styles.headerMenu}>
          <AppMenuTop />
        </div>
        <Drawer
          // style={{width:"300px"}}
          width={"70%"}
          placement="left"
          open={openMenu}
          closable={false}
          onClose={() => {
            setopenMenu(false);
          }}
        >
          <AppMenuTop inline drawer />
        </Drawer>
      </>
    );
  }
  return <></>;
};

const AppMenuTop = ({ inline = false, drawer = false }) => {
  const appContext = useContext(AppContext);
  const navigate = useNavigate();
  const [menus, setMenus] = useState([]);
  const [showMenuTop, setShowMenuTop] = useState(false);

  const onClick = (e) => {
    appContext.setCurrentMenuTop(e.key);
    console.log("click ", e);
    if (e.key === "main") {
      navigate(pathRoutes.main);
    } else if (e.key === "summary") {
      navigate(pathRoutes.summary);
    } else if (e.key === "lot-summary") {
      navigate(pathRoutes.lotSummary);
    } else if (e.key === "number-lot-summary") {
      navigate(pathRoutes.numberLotSummary);
    } else if (e.key === "check") {
      navigate(pathRoutes.check);
    } else if (e.key === "select-user") {
      navigate(pathRoutes.selectUser);
    } else if (e.key === "lot-resualt") {
      navigate(pathRoutes.lotResualt);
    } else if (e.key === "version2-resualt") {
      navigate(pathRoutes.lotResualtSet2);
    }
  };

  useEffect(() => {
    let url = window.location.href;

    if (url.indexOf("/main") != -1) {
      appContext.setCurrentMenuTop("main");
    } else if (url.indexOf("/summary") != -1) {
      appContext.setCurrentMenuTop("summary");
    } else if (url.indexOf("/lot-summary") != -1) {
      appContext.setCurrentMenuTop("lot-summary");
    } else if (url.indexOf("/number-lot-summary") != -1) {
      appContext.setCurrentMenuTop("number-lot-summary");
    } else if (url.indexOf("/check") != -1) {
      appContext.setCurrentMenuTop("check");
    } else if (url.indexOf("/lot-resualt") != -1) {
      appContext.setCurrentMenuTop("lot-resualt");
    } else if (url.indexOf("/select-user") != -1) {
      appContext.setCurrentMenuTop("select-user");
    } else if (url.indexOf("/version2-resualt") != -1) {
      appContext.setCurrentMenuTop("version2-resualt");
    }

    if (!checkEmpty(getToken())) {
      if (isAdmin()) {
        setMenus(menuAdmin);
      } else {
        setMenus(menuNotAdmin);
      }
    }
  }, []);

  const logout = () => {
    logoutApi();
    clearToken();
    navigate(pathRoutes.login);
  };

  const getusername = useMemo(() => {
    let user;
    try {
      user = parseJwt(getToken());
    } catch (e) {}
    let username = user?.username;
    return username;
  }, []);

  useEffect(() => {
    setInterval(function () {
      testConn();
    }, 60000);
  }, []);

  return (
    <>
      <Menu
        className={styles.menutopHedader}
        onClick={onClick}
        selectedKeys={[appContext.currentMenuTop]}
        mode={inline ? "inline" : "horizontal"}
        items={menus}
        style={{ fontSize: "18px" }}
      />
      <div className={styles.logout}>
        {/* <div className={styles.txtUser}>{getusername}</div> */}

        <div className={styles.btnLogout}>
          <Button danger onClick={logout}>
            {getusername + " "}Logout
          </Button>
        </div>
      </div>
    </>
  );
};

export default MenuTop;
